module.exports = __webpack_public_path__ + "img/locations.005cffdc.svg";